import Vue from 'vue';

import Alpine from 'alpinejs';

import Vue2TouchEvents from 'vue2-touch-events';
import { components } from './components';
import { directives } from './directives';
import pluginsInit from './plugins';

import './modules/video-bg-sizing';

Vue.use(Vue2TouchEvents);

const $app = window.$app || {};

window.Alpine = Alpine;
Alpine.start();

if ($app.devMode === 'true') {
    Vue.config.devtools = true;
}

if ($app.devMode === 'false') {
    Vue.config.devtools = false;
    Vue.config.productionTip = false;
}

Vue.prototype.$global = $app;

window.$vue = new Vue({
    el: '#root',
    delimiters: ['[[', ']]'],
    components,
    directives,
    mounted() {
        pluginsInit();
    },
});
